import {
	type FetchServicedeskPortalSuccessAction,
	FETCH_SERVICEDESK_PORTAL_SUCCESS,
} from './actions.tsx';
import type { State } from './types.tsx';

export const defaultState: State = {
	portalId: undefined,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State = defaultState, action: FetchServicedeskPortalSuccessAction) => {
	switch (action.type) {
		case FETCH_SERVICEDESK_PORTAL_SUCCESS: {
			return { portalId: action.payload.portalId };
		}
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
